/* === Align Product Card Elements Across Rows === */
(function () {
  'use strict';

  var SLOTS = [
    '.tt-title',
    '.thumbnail_small_description',
    '.tt-price',
    '.aros-cswatches',
    '.productitem-option1-js',
    '.productitem-option2-js',
    '.pl-swatches-collection'
  ];

  var CONTAINERS = '.tt-layout-product-item, .tt-product-listing.row';

  function alignCards() {
    /* Remove leftover spacer elements from previous code versions */
    var spacers = document.querySelectorAll('[class*="spacer"]');
    for (var s = 0; s < spacers.length; s++) spacers[s].parentNode.removeChild(spacers[s]);

    var containers = document.querySelectorAll(CONTAINERS);

    for (var ci = 0; ci < containers.length; ci++) {
      var container = containers[ci];
      var cols = container.querySelectorAll(':scope > [class*="col-"]');
      if (cols.length < 2) continue;

      /* Group cards by visual row using offsetTop (works for offscreen elements too) */
      var cardMap = {};
      for (var i = 0; i < cols.length; i++) {
        var card = cols[i].querySelector('.tt-product.product-parent');
        if (!card) continue;
        var key = Math.round(cols[i].offsetTop);
        if (!cardMap[key]) cardMap[key] = [];
        cardMap[key].push(card);
      }

      var keys = Object.keys(cardMap);
      for (var ki = 0; ki < keys.length; ki++) {
        var rowCards = cardMap[keys[ki]];
        if (rowCards.length < 2) continue;

        /*
         * TWO-PASS: measure first, apply once.
         *
         * Pass 1 — measure natural height+margins of each element.
         * Pass 2 — for each element:
         *   exists + shorter → increase min-height
         *   missing → accumulate gap, apply as margin-top on next element
         */

        /* PASS 1 */
        var grid = [];
        for (var ri = 0; ri < rowCards.length; ri++) {
          var row = [];
          for (var si = 0; si < SLOTS.length; si++) {
            var el = rowCards[ri].querySelector(SLOTS[si]);
            if (el && getComputedStyle(el).display !== 'none' && el.offsetHeight > 0) {
              var cs = getComputedStyle(el);
              row.push({
                el: el,
                h: el.offsetHeight,
                totalH: el.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0),
                exists: true
              });
            } else {
              row.push({ el: null, h: 0, totalH: 0, exists: false });
            }
          }
          grid.push(row);
        }

        /* Max per slot */
        var maxPerSlot = [];
        for (var si2 = 0; si2 < SLOTS.length; si2++) {
          var m = 0;
          for (var ri2 = 0; ri2 < grid.length; ri2++) {
            if (grid[ri2][si2].totalH > m) m = grid[ri2][si2].totalH;
          }
          maxPerSlot.push(m);
        }

        /* PASS 2 */
        for (var ri3 = 0; ri3 < grid.length; ri3++) {
          var accGap = 0;
          for (var si3 = 0; si3 < SLOTS.length; si3++) {
            var sd = grid[ri3][si3];
            if (sd.exists) {
              if (accGap > 0) {
                sd.el.style.marginTop = accGap + 'px';
                accGap = 0;
              }
              if (sd.totalH < maxPerSlot[si3]) {
                var diff = maxPerSlot[si3] - sd.totalH;
                sd.el.style.minHeight = (sd.h + diff) + 'px';
              }
            } else {
              accGap += maxPerSlot[si3];
            }
          }
        }
      }
    }
  }

  function resetAndAlign() {
    var all = document.querySelectorAll(
      '.tt-description:not(.onerowactions) > *, .tt-option-block > *'
    );
    for (var i = 0; i < all.length; i++) {
      all[i].style.minHeight = '';
      all[i].style.marginTop = '';
    }
    alignCards();
  }

  /* Run after page loads */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(resetAndAlign, 500);
    });
  } else {
    setTimeout(resetAndAlign, 500);
  }

  /* Re-run on resize */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resetAndAlign, 300);
  });

  /* Re-run on swatch click */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tt-options-swatch')) {
      setTimeout(resetAndAlign, 100);
    }
  });

  /*
   * MutationObserver — detect new products loaded by infinite scroll.
   * Watches for new child nodes added to product containers.
   */
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (
            node.classList.contains('tt-col-item') ||
            node.querySelector && node.querySelector('.tt-product')
          )) {
            hasNewCards = true;
            break;
          }
        }
      }
      if (hasNewCards) break;
    }
    if (hasNewCards) {
      setTimeout(resetAndAlign, 500);
    }
  });

  /* Observe all product containers for new children */
  function startObserving() {
    var containers = document.querySelectorAll(CONTAINERS);
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i], { childList: true, subtree: true });
    }
    /* Also observe body for new containers (e.g., homepage sections loading) */
    observer.observe(document.body, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

/* ===== Footer "manage cookies" link → open Shopify consent preferences directly =====
   The menu link points to ?preview_privacy_banner=1 (loads the homepage banner).
   Intercept it and open the native preferences modal in place instead. Falls back
   to the original navigation if the privacy API isn't available. */
(function () {
  function openCookiePrefs() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
      return true;
    }
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
      window.Shopify.customerPrivacy.showPreferences();
      return true;
    }
    return false;
  }
  function hasCookiePrefsApi() {
    return (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') ||
      (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function');
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="preview_privacy_banner"]');
    if (!link) return;
    if (!hasCookiePrefsApi()) return; /* fall back to default navigation */
    /* Capture phase + stop propagation: run before any theme/menu handler so
       nothing navigates the page or closes the modal. */
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    /* Defer to the next tick so THIS click fully finishes before the modal opens. */
    setTimeout(openCookiePrefs, 0);
  }, true);
})();

/* ===== Require an explicit size choice before Add to Cart works =====
   Both surfaces already ship the pieces needed to gate this: the grid card's
   swatch click handler in theme.min.js already toggles a `.disable` class on
   `.tt-btn-addtocart` based on the clicked variant's availability, and the
   product page's SwatchesConstructor already strips `.select_options` off the
   form wrapper the moment a real choice is made (after swatchVariantButtonHandler
   has already run, so `.disable` already reflects the new variant by then).
   Neither of them sets a *real* `disabled` attribute though — with nothing
   clicked, the hidden variant input still holds the first-available variant,
   so a click (or, on the product page before any handler is bound, a plain
   native form submit) would silently add it anyway. Liquid now renders both
   buttons `disabled` up front (see snippets/product-grid-item-design-1.liquid
   and snippets/product_page_1_description.liquid, both marked with
   data-aros-needs-size); this lifts that once the theme's own signals say a
   real choice happened, mirroring whatever `.disable` class state they
   already set for that variant. */
(function () {
  'use strict';

  /* Collection cards: fires on every size-swatch click, but only acts on
     cards that actually need a choice (data-aros-needs-size). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.productitem-option1-js li a');
    if (!a) return;
    var card = e.target.closest('.tt-product.product-parent');
    if (!card) return;
    var btn = card.querySelector('.tt-btn-addtocart[data-aros-needs-size]');
    if (!btn) return;
    btn.disabled = btn.classList.contains('disable');
  });

  /* Product page: watch for the theme's own "a real choice was made" signal
     instead of guessing SwatchesConstructor's internal swatch markup. */
  var wrappers = document.querySelectorAll('.tt-wrapper.select_options');
  if (!wrappers.length) return;
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target;
      if (el.classList.contains('select_options')) return;
      var btn = el.querySelector('.btn-addtocart[data-aros-needs-size]');
      if (btn) btn.disabled = btn.classList.contains('disable');
    });
  });
  wrappers.forEach(function (el) {
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
})();

/* ===== Add-to-cart confetti + inactive-tab attention blink =====
   First-party replacement for the "mega-emoji-tab-animation" app
   (Shopify app handle facebook-ads-google-ads-ai) so it can be
   uninstalled — that app also silently injects a second, undisclosed
   GTM container (GTM-5NGLZHXN) with its own GA4 property.

   Two independent, self-contained features, matching the app's live
   config (window.mpa_mct): confetti only on add-to-cart (welcome/
   product-page confetti were both off), plus the tab title/favicon
   blink with the same two messages and emoji.

   1. Confetti fires from Shopify.onItemAdded — the one callback every
      add-to-cart path already funnels through (grid-card quick-add,
      product page, quick view), and unlike Shopify.onCartUpdate it is
      ONLY invoked from the two add-item AJAX helpers' success handlers
      (verified against vendor.min.js — onCartUpdate is shared with
      remove/update/clear too, so hooking that would fire confetti on
      removals as well).
   2. While the tab is hidden, alternates the title and favicon between
      two messages/emoji to pull the shopper back — reverts the moment
      the tab regains focus. Uses the Page Visibility API rather than
      window blur/focus, since blur also fires for things like opening
      devtools.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- 1. Confetti on Add to Cart ---------- */

  var CONFETTI_COLORS = ['#f8353e', '#ffb703', '#2879fe', '#06d6a0', '#8338ec'];
  var confettiRunning = false;

  function burstConfetti() {
    if (confettiRunning) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    confettiRunning = true;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var particles = [];
    for (var i = 0; i < 140; i++) {
      particles.push({
        x: canvas.width / 2,
        y: canvas.height * 0.15,
        vx: (Math.random() - 0.5) * 16,
        vy: Math.random() * -8 - 2,
        size: Math.random() * 7 + 4,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        rot: Math.random() * 360,
        vrot: (Math.random() - 0.5) * 20,
        shape: Math.random() < 0.5 ? 'rect' : 'circle'
      });
    }

    var gravity = 0.45;
    var drag = 0.985;
    var start = null;
    var duration = 2600;

    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var stillFalling = false;
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.vy += gravity;
        p.vx *= drag;
        p.vy *= drag;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vrot;
        if (p.y < canvas.height + 40) stillFalling = true;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot * Math.PI / 180);
        ctx.fillStyle = p.color;
        if (p.shape === 'rect') {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }

      if (stillFalling && elapsed < duration) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
        confettiRunning = false;
      }
    }
    requestAnimationFrame(frame);
  }

  function initConfettiTrigger() {
    if (typeof window.Shopify === 'undefined') return;
    var original = window.Shopify.onItemAdded;
    window.Shopify.onItemAdded = function (lineItem) {
      if (typeof original === 'function') original.call(this, lineItem);
      burstConfetti();
    };
  }
  initConfettiTrigger();

  /* ---------- 2. Inactive-tab title/favicon blink ----------
     Enabled state and message text come from the "טיקר מבצעים" section's
     "כותרת טאב כשהעמוד לא בפוקוס" settings (sections/announcement-ticker.liquid
     sets window.__arosTabBlink before this file runs, independent of whether
     the ticker itself is enabled) — that's the merchant-facing control panel
     for this feature. Falls back to the original defaults if that global is
     missing for any reason (e.g. a template that doesn't render the section). */

  var tabBlinkConfig = window.__arosTabBlink || {};
  var BLINK_ENABLED = tabBlinkConfig.enabled !== false;
  var BLINK_MESSAGES = (tabBlinkConfig.messages || ['אל תפספסו', 'בקרוב המחירים עולים'])
    .filter(function (m) { return typeof m === 'string' && m.length > 0; });
  var BLINK_EMOJI = ['📢', '🫸🏻'];
  var BLINK_MS = 1200;

  var originalTitle = document.title;
  var originalFaviconHref = null;
  var faviconLink = null;
  var blinkTimer = null;
  var blinkStep = 0;

  function getFaviconLink() {
    var link = document.querySelector('link[rel~="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    return link;
  }

  function emojiFaviconDataUrl(emoji) {
    var canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    var ctx = canvas.getContext('2d');
    ctx.font = '54px serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(emoji, 32, 38);
    return canvas.toDataURL('image/png');
  }

  function startBlink() {
    if (blinkTimer) return;
    faviconLink = getFaviconLink();
    originalFaviconHref = faviconLink.href;
    originalTitle = document.title;
    blinkStep = 0;
    blinkTimer = setInterval(function () {
      document.title = BLINK_MESSAGES[blinkStep % BLINK_MESSAGES.length];
      faviconLink.href = emojiFaviconDataUrl(BLINK_EMOJI[blinkStep % BLINK_EMOJI.length]);
      blinkStep++;
    }, BLINK_MS);
  }

  function stopBlink() {
    if (!blinkTimer) return;
    clearInterval(blinkTimer);
    blinkTimer = null;
    document.title = originalTitle;
    if (faviconLink && originalFaviconHref) faviconLink.href = originalFaviconHref;
  }

  if (BLINK_ENABLED && BLINK_MESSAGES.length > 0) {
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) startBlink();
      else stopBlink();
    });
  }
})();
